import { ItemList } from "../orm";

class FacialRecognitionProgressList extends ItemList {
  getEntityKey() {
    return "photographer/gallery/facial_recognition_progress";
  }

  facialRecognitionProgress(galleryId) {
    return async (dispatch, getState) => {
      await dispatch(this.clearListFilter());
      await dispatch(
        this.updateListFilter({
          gallery_id: galleryId,
        }),
      );
      if (galleryId) {
        return await dispatch(this.fetchListIfNeeded());
      }
      return Promise.resolve({});
    };
  }
}

export const facialRecognitionProgressList =
  new FacialRecognitionProgressList(
    "facial_recognition_progress__default",
  );
